import { render, staticRenderFns } from "./RecentWork.vue?vue&type=template&id=df34a316&scoped=true&"
import script from "./RecentWork.vue?vue&type=script&lang=ts&"
export * from "./RecentWork.vue?vue&type=script&lang=ts&"
import style0 from "./RecentWork.vue?vue&type=style&index=0&id=df34a316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df34a316",
  null
  
)

export default component.exports